export const DID_KEY = "eGlvbmdmZW5nLnpob3VAYm9yaW5ncG93ZXIuY29t:l5iqo_T3NnjzEnutQhyyO";
export const DEFAULT_VIDEO_URL = "/laura.mp4"
export const PHOTO_URL = 'https://s3-evan.s3.amazonaws.com/lady0.png'

export const API_URL = "https://aa.findme365.com/api/"

export const PUCT_number :any = {
    '210': '10259', // Pulse
    '194': '10105', // APGE
    '183': '10098', // Champion
    '239': '10279', // Rhythm
    '258': '10293', // Value Power
    '196': '10014', // Constellation
};